import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-613dea26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-body" }
const _hoisted_2 = { class: "has-background-contents shadow search-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_About = _resolveComponent("About")!
  const _component_Request = _resolveComponent("Request")!
  const _component_Reference = _resolveComponent("Reference")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Inquiry = _resolveComponent("Inquiry")!
  const _component_IncludeHtmlViewer = _resolveComponent("IncludeHtmlViewer")!
  const _component_SideMenu = _resolveComponent("SideMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_About),
      _hoisted_3,
      _createVNode(_component_Request),
      _hoisted_4,
      _createVNode(_component_Reference),
      _hoisted_5,
      _createVNode(_component_Notification),
      _hoisted_6,
      _createVNode(_component_Inquiry),
      _hoisted_7,
      _createVNode(_component_IncludeHtmlViewer, {
        htmlName: 'rightprocessing.html',
        hash: _ctx.hash
      }, null, 8, ["htmlName", "hash"])
    ]),
    _createVNode(_component_SideMenu)
  ]))
}